import { colors } from '@ardoq/design-tokens';
import styled from 'styled-components';

export const Separator = styled.div`
  border-bottom: 1px solid ${colors.borderSubtle};
  width: 100%;
`;
